import React, { useEffect, useState } from "react";
import * as serviceWorkerRegistration from "../serviceWorkerRegistration";

function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [waitingWorker, setWaitingWorker] = useState(null);
  const [visible, setVisible] = useState(false);
  const [hideOnScroll, setHideOnScroll] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    // Detect iOS Safari
    const ua = window.navigator.userAgent;
    const iOS =
      /iPad|iPhone|iPod/.test(ua) &&
      !window.MSStream &&
      "standalone" in window.navigator &&
      !window.navigator.standalone;
    setIsIOS(iOS);

    if (!iOS) {
      const handleBeforeInstallPrompt = (e) => {
        e.preventDefault();
        console.log("📲 beforeinstallprompt fired");
        setDeferredPrompt(e);
        setVisible(true);
      };
      window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

      serviceWorkerRegistration.register({
        onUpdate: (registration) => {
          if (registration?.waiting) {
            setWaitingWorker(registration.waiting);
            setVisible(true);
          }
        },
      });

      const handleScroll = () => {
        if (window.scrollY > 60) setHideOnScroll(true); // ✅ hide after 60px
        else setHideOnScroll(false);
      };
      window.addEventListener("scroll", handleScroll);

      return () => {
        window.removeEventListener(
          "beforeinstallprompt",
          handleBeforeInstallPrompt
        );
        window.removeEventListener("scroll", handleScroll);
      };
    } else {
      // iOS → show custom banner after delay
      setTimeout(() => setVisible(true), 2000);
    }
  }, []);

  // ✅ Auto-hide after 10s if no action
  useEffect(() => {
    let timer;
    if (visible) {
      timer = setTimeout(() => setVisible(false), 60000);
    }
    return () => clearTimeout(timer);
  }, [visible]);

  const handleActionClick = async () => {
    if (waitingWorker) {
      waitingWorker.postMessage({ type: "SKIP_WAITING" });
      waitingWorker.addEventListener("statechange", (e) => {
        if (e.target.state === "activated") {
          window.location.reload();
        }
      });
    } else if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      console.log("User choice:", outcome);
      setDeferredPrompt(null);
    }
    setVisible(false);
  };

  const handleClose = () => setVisible(false);

  let message = "";
  let buttonLabel = "";

  if (isIOS) {
    message =
      "📲 Add MyEarningsNow to your Home Screen:\n Tap Share → 'Add to Home Screen'";
    buttonLabel = "Got It";
  } else if (waitingWorker) {
    message = "🚀 A new version is available!";
    buttonLabel = "Update Now";
  } else if (deferredPrompt) {
    message = "📲 Install MyEarningsNow on your device?";
    buttonLabel = "Install";
  }

  if (!visible || !message || hideOnScroll) return null;

  return (
    <div style={bannerStyle} className="install-banner">
      <span style={textStyle(isIOS)}>{message}</span>
      <div style={btnGroupStyle}>
        <button
          style={btnStyle}
          onClick={isIOS ? handleClose : handleActionClick}
        >
          {buttonLabel}
        </button>
        <button style={closeBtnStyle} onClick={handleClose}>
          ×
        </button>
      </div>
    </div>
  );
}

// 🔹 Styles
const bannerStyle = {
  position: "fixed",
  top: "60px",
  right: window.innerWidth <= 768 ? "10px" : "30px", // 👈 mobile vs large
  background: "#fff",
  border: "1px solid #ddd",
  borderRadius: "6px",
  padding: "6px 10px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "8px",
  zIndex: 2000,
  animation: "slideIn 0.5s ease-out",
  maxWidth: "95vw",
  overflow: "hidden",
};


// ✅ Dynamic style for iOS vs Others
const textStyle = (isIOS) => ({
  flex: "1",
  fontSize: "clamp(12px, 1.6vw, 14px)",
  lineHeight: isIOS ? "1.4" : "1.3",
  whiteSpace: isIOS ? "normal" : "nowrap", // ✅ wrap for iOS, single line otherwise
  wordBreak: "break-word",
  overflow: "hidden",
});

const btnGroupStyle = {
  display: "flex",
  flexShrink: 0,
  gap: "6px",
  alignItems: "center",
};

const btnStyle = {
  padding: "4px 10px",
  border: "none",
  borderRadius: "4px",
  background: "#007bff",
  color: "#fff",
  cursor: "pointer",
  fontWeight: "bold",
  fontSize: "clamp(11px, 1.6vw, 13px)",
};

const closeBtnStyle = {
  padding: "4px 8px",
  border: "none",
  borderRadius: "4px",
  background: "#dc3545",
  color: "#fff",
  cursor: "pointer",
  fontWeight: "bold",
  fontSize: "clamp(11px, 1.6vw, 13px)",
};

// 🔹 Inject keyframes
const styleSheet = document.styleSheets[0];
if (styleSheet) {
  styleSheet.insertRule(
    `
    @keyframes slideIn {
      from { opacity: 0; transform: translateY(-20px); }
      to { opacity: 1; transform: translateY(0); }
    }
  `,
    styleSheet.cssRules.length
  );
}

export default InstallPrompt;
